<template>
  <v-sheet class="live-trade-card" color="rgba(3, 157, 233, 0.08)">
    <v-card-text class="trade px-0 pb-4 pt-2">
      <div class="d-flex align-start">
        <v-icon class="blink" color="#FF567F"> mdi-circle-small </v-icon>
        <p class="ma-0">
          Live Trades <span class="equity-text">Total
            Lot: {{ formattedAllNumber(dashboardLiveTradesData?.totalVolume) }}</span>
        </p>
        <div class="circle-indicator" :class="{ 'loading': isLoading }">
          <v-icon v-if="!isLoading" class="ml-0.5 mb-0.5" size="medium" color="#708AA7" @click="refreshTrades"
            title="Refresh Live Trades">
            mdi-refresh
          </v-icon>
          <v-icon v-else class="rotating ml-2 mb-0.5" size="medium" color="#708AA7">mdi-loading</v-icon>
        </div>
      </div>
      <v-spacer></v-spacer>
      <router-link class="links" to="/live-trades">See All ></router-link>
    </v-card-text>

    <v-card-text class="pa-0 liveTradeChart">
      <p>
        <LiveTradeChart></LiveTradeChart>
      </p>
    </v-card-text>

    <v-card-text class="pl-3 pr-0 pb-4 trade">
      <span class="number">
        {{ dashboardLiveTradesData?.total }}
      </span>

      <v-spacer></v-spacer>

      <span class="equity">Profit: <strong
          :style="{ color: dashboardLiveTradesData?.totalProfit < 0 ? '#ff567f' : null }">
          {{ formattedAllNumber(dashboardLiveTradesData?.totalProfit) }} USD
        </strong>
      </span>
    </v-card-text>
  </v-sheet>
</template>

<script>
import { formatNumber } from "@/_helpers/formatNumber";
import { LIVETRADES__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import LiveTradeChart from "./LiveTradeChart.vue";

export default {
  components: { LiveTradeChart },
  data: () => ({
    isLoading: false
  }),

  computed: {
    ...mapState("livetrades", ["dashboardLiveTradesData"]),
  },

  methods: {
    ...mapActions("livetrades", [LIVETRADES__ACTIONS.DASHBOARDLIVETRADES]),

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },

    async refreshTrades() {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this[LIVETRADES__ACTIONS.DASHBOARDLIVETRADES]();
      } finally {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      }
    }
  },

  async created() {
    await this[LIVETRADES__ACTIONS.DASHBOARDLIVETRADES]();
  },
};
</script>

<style scoped>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.rotating {
  animation: spin 1s linear infinite;
}

.circle-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>